var map = {
	"./2FA-icon-red.png": 9804,
	"./Email.svg": 16722,
	"./Line.svg": 3756,
	"./Messenger.svg": 75141,
	"./Telegram.svg": 38957,
	"./Wechat.svg": 17521,
	"./Whatsapp.svg": 12292,
	"./address-icon.png": 93003,
	"./buddybonus.png": 6671,
	"./close-circle.png": 53690,
	"./cookie_policy.png": 82379,
	"./expired.png": 79289,
	"./info-circle-dark.png": 16096,
	"./info-circle.png": 98088,
	"./info-circle.svg": 12141,
	"./info.png": 9370,
	"./invalid.png": 23156,
	"./no-address.png": 29916,
	"./pending-current.png": 65792,
	"./pending-grey-icon.png": 39851,
	"./pending.png": 84350,
	"./pending2.png": 29025,
	"./pending3.png": 38561,
	"./platform-icon.png": 77170,
	"./profile-info.png": 22270,
	"./rejected-dark-icon.png": 32561,
	"./rejected-icon.png": 32846,
	"./rejected.png": 45825,
	"./security.png": 18082,
	"./share-icon.png": 31956,
	"./success.png": 93847,
	"./warning-dark.png": 51879,
	"./warning.png": 14787,
	"./white-close-circle.png": 529,
	"./white-warning.png": 93413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42970;